import { Avatar, Button } from '@efexteam/components';
import { Actions, Subjects, usePermission } from '@efexteam/permission-manager';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import { Box, Container, Grid, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import DeleteModal from './components/deleteModal';
import EditModal from './components/editModal';
import InfoCard from './components/infoCard';
import RoleCard from './components/roleCard';
import EditTeamMemberStyles from './EditTeamMember.style';
import EditTeamMemberSkeleton from './EditTeamMemberSkeleton';
import useEditMember from './hooks/useEditMember';

const EditTeamMember = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { can } = usePermission();

  const {
    teamMemberId,
    teamMemberData,
    loading,
    teamMemberControlStatus,
    teamMemberRole,
    isTouched,
    openUpdateModal,
    openDeleteModal,
    updateMemberStatus,
    updateMemberRole,
    setOpenUpdateModal,
    setOpenDeleteModal,
  } = useEditMember();

  if (!can(Actions.UPDATE, Subjects.TEAM_MEMBERS)) {
    return <Navigate to="/dashboard" />;
  }

  if (loading) {
    return <EditTeamMemberSkeleton />;
  }

  if (!teamMemberId || !teamMemberData) {
    return <Typography>{t('teamMemberNotFound')}</Typography>;
  }

  const { firstName = '', lastName = '' } = teamMemberData.naturalPerson || {};
  const { id: roleId } = teamMemberData.platformRole || {};
  const fullName = `${firstName} ${lastName}`.trim();

  return (
    <Container maxWidth="lg">
      <Box className={EditTeamMemberStyles.wrapper}>
        <Box className={EditTeamMemberStyles.header}>
          <IconButton onClick={() => navigate('/profile?view=team')}>
            <ChevronLeftOutlinedIcon />
          </IconButton>
          <Avatar size="lg" username={fullName} />
          <Typography variant="h6">{fullName}</Typography>
          <Button
            appearance="primary"
            className={EditTeamMemberStyles.editButton}
            disabled={!isTouched}
            onClick={() => setOpenUpdateModal(true)}
          >
            {t('editMmbUpdateRole')}
          </Button>
        </Box>
        <Grid container spacing={2}>
          <InfoCard
            teamMemberData={teamMemberData}
            teamMemberControlStatus={teamMemberControlStatus}
            updateMemberStatus={updateMemberStatus}
            setOpenDeleteModal={setOpenDeleteModal}
          />
          {/* eslint-disable-next-line no-console */}
          {roleId && (
            <RoleCard roleId={teamMemberRole} setRoleId={updateMemberRole} />
          )}
        </Grid>
      </Box>
      <EditModal
        memberData={teamMemberData}
        open={openUpdateModal}
        status={teamMemberControlStatus}
        role={teamMemberRole}
        onClose={() => setOpenUpdateModal(false)}
      />
      <DeleteModal
        memberData={teamMemberData}
        open={openDeleteModal}
        role={teamMemberRole}
        onClose={() => setOpenDeleteModal(false)}
      />
    </Container>
  );
};

export default EditTeamMember;
